import { render, staticRenderFns } from "./BatchesFilters.vue?vue&type=template&id=701586f5&"
import script from "./BatchesFilters.vue?vue&type=script&lang=js&"
export * from "./BatchesFilters.vue?vue&type=script&lang=js&"
import style0 from "./BatchesFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701586f5')) {
      api.createRecord('701586f5', component.options)
    } else {
      api.reload('701586f5', component.options)
    }
    module.hot.accept("./BatchesFilters.vue?vue&type=template&id=701586f5&", function () {
      api.rerender('701586f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/BatchesFilters.vue"
export default component.exports